export default "__VITE_ASSET__BHI5GGXL__"